import { useIntl } from 'react-intl';

import { RecommendationType } from '@xing-com/crate-common-graphql-types';
import SearchAndSwipe from '@xing-com/crate-dream-machine-search-and-shuffle';

import { SearchAndSwipeContainer } from './container.style';
import { useSearchAndSwipeData } from './use-search-and-swipe-data';
import { useYourJobsData } from './use-your-jobs-data';

export const Container: React.FC = () => {
  const intl = useIntl();

  const config = {
    filter: {
      selectLabel: 'Select a card type',
      options: [
        {
          label: intl.formatMessage({
            id: 'SEARCH_AND_SWIPE_ALL_JOBS',
            defaultMessage: 'SEARCH_AND_SWIPE_ALL_JOBS',
          }),
          value: RecommendationType.All,
        },
        {
          label: intl.formatMessage({
            id: 'SEARCH_AND_SWIPE_AVAILABLE_JOBS_ONLY',
            defaultMessage: 'SEARCH_AND_SWIPE_AVAILABLE_JOBS_ONLY',
          }),
          value: RecommendationType.Available,
        },
        {
          label: intl.formatMessage({
            id: 'SEARCH_AND_SWIPE_TAKEN_JOBS_ONLY',
            defaultMessage: 'SEARCH_AND_SWIPE_TAKEN_JOBS_ONLY',
          }),
          value: RecommendationType.Taken,
        },
      ],
    },
    savedCards: {
      url: '/jobs/my-jobs',
      titleKey: 'SEARCH_AND_SHUFFLE_YOUR_JOBS_TITLE',
    },
  };

  return (
    <SearchAndSwipeContainer>
      <SearchAndSwipe
        useData={useSearchAndSwipeData}
        useSavedData={useYourJobsData}
        config={config}
        hideSavedCards
        hideAds
      />
    </SearchAndSwipeContainer>
  );
};
